import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_athlete/questionnaire-submissions",
)({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        href: "/questionnaire-submissions",
        labelTranslationKey: "formsPage.title",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
